import React from 'react';
import PropTypes from 'prop-types';
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import PlaceholderSpinner from 'components/kea/placeholders/PlaceholderSpinner';
import CardContainer from 'components/kea/CardContainer';
import DashboardStub from 'components/kea/DashboardStub';
import { analyticsChartTheme, formatCompactMetric } from 'util/chartUtils';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import styles from './TrendingWidget.module.scss';

const TrendingWidget = ({ chartData }) => {
  const localizeMessage = useLocalizedMessage();
  const hasData = Array.isArray(chartData) && chartData.some(row => Number(row.count) > 0);
  return (
    <CardContainer headerPostfix={localizeMessage('analytics.product.viewsTrend.title')}>
      {!chartData && <PlaceholderSpinner height={260} />}
      {chartData && !hasData && (
        <DashboardStub variant="line" messageId="analytics.product.viewsTrend.empty" />
      )}
      {hasData && (
        <div className={styles.chartFrame}>
          <ResponsiveContainer width="100%" height={280}>
            <AreaChart data={chartData} margin={{ top: 12, right: 18, left: 0, bottom: 8 }}>
              <defs>
                <linearGradient id="product-views-fill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={analyticsChartTheme.searchesFill} stopOpacity={1} />
                  <stop offset="100%" stopColor={analyticsChartTheme.searchesFill} stopOpacity={0.1} />
                </linearGradient>
              </defs>
              <CartesianGrid stroke={analyticsChartTheme.grid} vertical={false} strokeDasharray="2 7" />
              <XAxis dataKey="label" axisLine={false} tickLine={false} minTickGap={28} tick={{ fill: analyticsChartTheme.muted, fontSize: 10 }} />
              <YAxis axisLine={false} tickLine={false} width={44} tickFormatter={formatCompactMetric} tick={{ fill: analyticsChartTheme.muted, fontSize: 10 }} />
              <Tooltip />
              <Area dataKey="count" name={localizeMessage('analytics.table.views')} type="monotone" stroke={analyticsChartTheme.searches} strokeWidth={2.5} fill="url(#product-views-fill)" dot={false} isAnimationActive={false} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </CardContainer>
  );
};

TrendingWidget.propTypes = {
  chartData: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    count: PropTypes.number,
  })),
};

TrendingWidget.defaultProps = { chartData: null };

export default TrendingWidget;
